import { updateProgramCustomStyles } from 'app/crud/programCustomStyles.crud';
import { createProgram, updateProgram } from 'app/crud/programs.crud';
import { getMetadataArray } from 'app/services/metadata.service';
import store from 'app/store/store';
import i18next from 'app/translations/i18n';
import { getDomainTenant } from 'app/utils/url';
import axios from 'axios';
import isEqual from 'lodash/isEqual';

export async function createProgramService(data) {
  const response = await createProgram(getDataGeneral(data));
  const { guid } = response.data.data;

  return { guid };
}

export function updateService(data) {
  return updateProgram(getDataUpdate(data));
}

export function updateLookAdvancedService({ data, newData }) {
  // Compara el data original con el newData para ver si hay cambios
  const isDifferent = !isEqual(data, newData);
  if (!isDifferent) return;

  // Creamos un objeto con los datos que se van a guardar, solo los que tienen prefijo custom_ y ademas quitamos el prefijo de las keys
  // Generado con IA
  const dataToSave = Object.keys(newData).reduce((acc, key) => {
    if (key.startsWith('custom_')) {
      acc[key.replace('custom_', '')] = newData[key];
    }
    return acc;
  }, {});

  // si border_radious es null, se elimina el campo
  if (dataToSave.border_radious === null || dataToSave.border_radious === undefined || dataToSave.border_radious === '') {
    delete dataToSave.border_radious;
  }

  return updateProgramCustomStyles(data.guid, dataToSave);
}

// ---------------------------------------------------------------
// Auxiliary functions
// ---------------------------------------------------------------

function getDataGeneral(data) {
  const font = store.getState()?.entities?.typographyProgram?.typography[0];

  return {
    body_typeface_guid: font?.guid,
    colour_mint: '#ed7011',
    country_guid: data?.country?.value || undefined,
    description: data?.description || '',
    education_discipline_guid: data?.discipline?.value,
    education_year_guid: data?.educationYears?.value,
    evaluation_period: data?.evaluation_period,
    has_power_lesson: data?.has_power_lesson ? 1 : 0,
    is_powerlesson_limited: data?.is_powerlesson_limited ? 1 : 0,
    heading_typeface_guid: font?.guid,
    is_accessible: data.is_accessible ? 1 : 0,
    isbn_student: data?.isbn_student || null,
    isbn_teacher: data?.isbn_teacher || null,
    json_config: data?.templateConfig || '{}',
    langs: getMetadataArray(data, 'langs'),
    name: data?.name,
    program_type: data?.program_type || undefined,
    publication_guid: data?.publication_guid,
    structure_levels: data?.structure_levels,
    template_type: data?.template?.value,
  };
}

function getDataUpdate(data) {
  return {
    background: data?.background === '' ? '' : undefined,
    body_typeface_guid: data?.body_typeface_guid,
    colour_mint: data?.colour_mint,
    config: data?.config || '',
    country_guid: data?.country?.value || undefined,
    description: data?.description || '',
    education_discipline_guid: data?.discipline?.value,
    education_year_guid: data?.educationYears?.value,
    evaluation_period: data?.evaluation_period,
    guid: data?.guid,
    has_power_lesson: data?.has_power_lesson ? 1 : 0,
    is_powerlesson_limited: data?.is_powerlesson_limited ? 1 : 0,
    has_tangerine_ai: data?.has_tangerine_ai ? 1 : 0,
    heading_typeface_guid: data?.heading_typeface_guid,
    is_accessible: data?.is_accessible ? 1 : 0,
    isbn_student: data?.isbn_student || null,
    isbn_teacher: data?.isbn_teacher || null,
    json_config: data?.templateConfig || '{}',
    langs: getMetadataArray(data, 'langs'),
    name: data?.name,
    picture: data?.picture === '' ? '' : undefined,
    program_cover: data?.program_cover === '' ? '' : undefined,
    program_type: data?.program_type || undefined,
    publication_guid: data?.publication_guid,
    structure_levels: data?.structure_levels,
    subtitle: data?.subtitle,
    template_type: data?.template?.value,
  };
}

// ---------------------------------------------------------------
// ACCESS FRONTOFFICE
// ---------------------------------------------------------------
export function openProgramFrontOffice({ user, relativeUrl, tenant, program }) {
  const URL = getDomainTenant({ tenant, user: { ...user, country_guid: program?.country_guid || program?.country?.value } });

  return new Promise(async (resolve) => {
    const response = await axios.post(`users/${user.guid}/login`, { data: {} });
    const data = response?.data?.data;

    window.open(`${URL}auth/login/${data?.token}/course&${relativeUrl}`);
    resolve(data);
  });
}

export function editProgram({ program, user, tenant }) {
  const relativeUrl = program.has_home ? `${program.guid}&home` : `${program.guid}&program`;
  openProgramFrontOffice({ user, relativeUrl, tenant, program });
}

export function editProgramLesson({ program, lessonGuid, user, tenant }) {
  openProgramFrontOffice({ user, relativeUrl: `${program.guid}&lesson&${lessonGuid}`, tenant, program });
}

// ---------------------------------------------------------------
// GENERAL
// ---------------------------------------------------------------
export const TRIMESTERS = [
  { guid: '{"trimestre_guid":"1"}', name: i18next.t('digitalPrograms:trimester_1') },
  { guid: '{"trimestre_guid":"2"}', name: i18next.t('digitalPrograms:trimester_2') },
  { guid: '{"trimestre_guid":"3"}', name: i18next.t('digitalPrograms:trimester_3') },
];

export const RESOURCE_TREASURE_HUNT = {
  treasure_hunt: [
    { name: '', guid: '' },
    { name: '', guid: '' },
    { name: '', guid: '' },
  ],
};

export const TEMPLATES_DEFAULT = [{ template_type: 'vanilla', description: 'Standard template of Tangerine' }];

export function getTemplate() {
  const TEMPLATES = store.getState().entities.templates.templates;
  return TEMPLATES.length ? TEMPLATES : TEMPLATES_DEFAULT;
}
